// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3rd-party-retailers_bg__y2jCB","copy":"_3rd-party-retailers_copy__-74d3","heading":"_3rd-party-retailers_heading__gCpcT"};